import { SchoolPagination } from "@carnegie-learning/data-access-angular-passport";
import { School, User } from "@carnegie-learning/data-access-fido";
import { Action, createReducer, on } from "@ngrx/store";
import * as fromSchoolsActions from "../actions/schools.action";

export interface SchoolsListState {
    entities: Map<string, School>;
    passportSchoolIDs: Map<string, string>;
    loaded: boolean;
    loading: boolean;
    rawResponse: SchoolPagination | null;
    // paginationParams: SchoolPaginationParameters;
    schoolFidoStudents: Map<string, User>;
}

export const initialState: SchoolsListState = {
    entities: new Map<string, School>(),
    passportSchoolIDs: new Map<string, string>(),
    loaded: false,
    loading: false,
    rawResponse: null,
    // paginationParams: {
    //     limit: 10,
    //     page: 0,
    //     filter: {
    //         'archived': false
    //     }, // true - only archived records, false - only active records, don't include param means everything
    //     search: "",
    //     sorting: { schoolName: "asc" },
    //     total: 0,
    //     withSchoolSeatStatus: 0
    // },
    schoolFidoStudents: new Map<string, User>(),
};
const schoolsListReducer = createReducer(
    initialState,
    on(
        fromSchoolsActions.loadDistrictSchools,
        fromSchoolsActions.loadTeacherSchools,
        fromSchoolsActions.loadSchoolFidoStudents,
        fromSchoolsActions.loadCoursesSchool,
        (state) => {
            return {
                ...state,
                loading: true,
                loaded: false,
            };
        }
    ),
    on(
        fromSchoolsActions.loadSchoolsFail,
        fromSchoolsActions.loadCoursesSchoolFail,
        (state) => {
            return {
                ...state,
                loaded: false,
                loading: false,
            };
        }
    ),

    on(fromSchoolsActions.loadSchoolsSuccess, (state, { payload }) => {
        const schools = payload.data;

        const entities = new Map<string, School>();
        schools.forEach((school) => {
            entities.set(<string>school.schoolid, school);
        });

        // then re-bind the entity const with our returned state
        return {
            ...state,
            loading: false,
            loaded: true,
            entities: entities,
            rawResponse: payload,
        };
    }),
    on(fromSchoolsActions.loadTeacherSchoolsSuccess, (state, { payload }) => {
        const schools = payload.data;

        const passportSchoolIDs = new Map<string, string>();
        schools.forEach((school) => {
            passportSchoolIDs.set(school.schoolID, school.schoolID);
        });

        // then re-bind the entity const with our returned state
        return {
            ...state,
            loading: false,
            loaded: true,
            passportSchoolIDs: passportSchoolIDs,
        };
    }),

    on(fromSchoolsActions.loadCoursesSchoolSuccess, (state, { payload }) => {
        const schools = payload.list;

        const entities = new Map<string, School>(state.entities.entries());

        schools.forEach((school) => {
            entities.set(<string>school.schoolid, school);
        });

        // then re-bind the entity const with our returned state
        return {
            ...state,
            loading: false,
            loaded: true,
            entities: entities,
        };
    }),
    on(fromSchoolsActions.loadSchoolFidoStudentsFail, (state) => {
        return {
            ...state,
            loaded: true,
            loading: false,
        };
    }),
    on(fromSchoolsActions.loadSchoolFidoStudentsSuccess, (state, { res }) => {
        const noNextPage =
            !res.pagingparameter ||
            res.pagingparameter === "NO_MORE" ||
            (<any>window).isDemo;
        let students: User[] = [];
        if (res?.list && (<any>res.list).user) {
            if (!Array.isArray((<any>res.list).user)) {
                // single results is returned object not an array
                students = [(<any>res.list).user];
            } else {
                students = (<any>res.list).user;
            }
        }
        const schoolFidoStudents = new Map<string, User>(
            state.schoolFidoStudents.entries()
        );
        if (students?.length) {
            if (!(<any>window).isDemo) {
                students.forEach((stu) => {
                    schoolFidoStudents.set(stu.id, stu);
                });
            } else {
                const iteration = students.length > 50 ? 50 : students.length;
                for (let i = 0; i < iteration; i++) {
                    // PAS-10060 for demo we only showing the first 50 students
                    if (students[i]) {
                        schoolFidoStudents.set(students[i].id, students[i]);
                    }
                }
            }
        }
        return {
            ...state,
            loading: false,
            loaded: noNextPage,
            schoolFidoStudents,
        };
    })
);
export function reducer(state: SchoolsListState | undefined, action: Action) {
    return schoolsListReducer(state, action);
}

export const getSchoolsEntities = (state: SchoolsListState) => state.entities;
export const getTeacherSchools = (state: SchoolsListState) =>
    state.passportSchoolIDs;
export const getSchoolsLoading = (state: SchoolsListState) => state.loading;
export const getSchoolsLoaded = (state: SchoolsListState) => state.loaded;

export const getRawSchoolsResponse = (state: SchoolsListState) =>
    state.rawResponse;
// export const getPaginationParams = (state: SchoolsListState) =>
//     state.paginationParams;
export const getSchoolFidoStudentsEntities = (state: SchoolsListState) =>
    state.schoolFidoStudents;
